angular.module('impactx.multimedia').controller('EmptyMMDListCtrl', EmptyMMDListCtrl);

function EmptyMMDListCtrl() {
    this.meta = {
        rowTemplate: 'modules/multimedia/templates/emptymmdlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/multimedia/emptymmd/list',
        ctrl: this,
        id: "emptymmdlist",
        excelExport: true
    };
    this.getMeta = function() {
        return this.meta;
    };
}